import { render } from "./PaymentProcessing.vue?vue&type=template&id=0b57186a&ts=true"
import script from "./PaymentProcessing.vue?vue&type=script&lang=ts"
export * from "./PaymentProcessing.vue?vue&type=script&lang=ts"

import "./PaymentProcessing.vue?vue&type=style&index=0&id=0b57186a&lang=scss"

import exportComponent from "/github/workspace/customer/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__